import React from "react";
import { Link } from "react-router-dom";
import { CONFIRMATION_DISCLAIMER_LINES } from "../content/eventsTermsContent";

/** Compact legal disclaimer for booking confirmation / ticket / QR views. */
export default function EventTermsDisclaimerStrip(props) {
  var className = props.className || "ev-terms-disclaimer";
  return (
    <div className={className} role="note" aria-label="Important legal notice">
      <div className="ev-terms-disclaimer__icon-row">
        <span className="ev-terms-disclaimer__icon" aria-hidden="true">🛡</span>
        <strong className="ev-terms-disclaimer__heading">Important notice</strong>
      </div>
      <ul className="ev-terms-disclaimer__list">
        {CONFIRMATION_DISCLAIMER_LINES.slice(0, -1).map(function (line) {
          return (
            <li key={line} className="ev-terms-disclaimer__item">
              {line}
            </li>
          );
        })}
      </ul>
      <Link to="/events/terms-and-conditions" className="ev-terms-disclaimer__link">
        View full Terms &amp; Conditions ↗
      </Link>
    </div>
  );
}
